const treasureChestRoutes = [
  {
    path: '/treasureChest',
    meta: { title: '投标宝箱' },
    children: [
      {
        path: 'consultant',
        name: 'TreasureChestConsultant',
        component: () => import('@/views/treasure-chest/consultant'),
        meta: {
          layout: 'HomeLayout',
          title: '投标顾问',
          pageType: 'public',
          cache: true
        }
      },
      {
        path: 'notice',
        name: 'TreasureChestNotice',
        component: () => import('@/views/treasure-chest/network-notice'),
        meta: {
          layout: 'HomeLayout',
          title: '全网商机',
          pageType: 'public',
          cache: true
        }
      },
      {
        path: 'subscription',
        name: 'TreasureChestSubscription',
        component: () => import('@/views/treasure-chest/subscription'),
        meta: {
          layout: 'HomeLayout',
          title: '标讯订阅',
          pageType: 'public',
          cache: true
        }
      },
      {
        path: 'competitor',
        name: 'TreasureChestCompetitor',
        component: () => import('@/views/treasure-chest/competitor-analysis'),
        meta: {
          layout: 'HomeLayout',
          title: '竞争对手分析',
          pageType: 'public',
          cache: true
        }
      },
      {
        path: 'purchaser',
        name: 'TreasureChestPurchaser',
        component: () => import('@/views/treasure-chest/purchaser-analysis'),
        meta: {
          layout: 'HomeLayout',
          title: '采购单位分析',
          pageType: 'public',
          cache: true
        }
      },
      {
        path: 'custom',
        name: 'TreasureChestCustomData',
        component: () => import('@/views/treasure-chest/custom-data'),
        meta: {
          layout: 'HomeLayout',
          title: '数据定制导出',
          pageType: 'public',
          cache: true
        }
      },
      {
        path: 'treasureChestFollow',
        name: 'TreasureChestFollow',
        component: () => import('@/views/treasure-chest/follow'),
        meta: {
          layout: 'HomeLayout',
          title: '我的关注',
          pageType: 'public',
          cache: true
        }
      },
      {
        path: 'bond',
        name: 'TreasureChestBond',
        component: () => import('@/views/treasure-chest/bond'),
        meta: {
          layout: 'HomeLayout',
          title: '会员保证金担保',
          pageType: 'public',
          cache: true
        }
      }
    ]
  }
]

export default treasureChestRoutes
